import { render, staticRenderFns } from "./ConfirmAtivarInativarDoseModal.vue?vue&type=template&id=19f74bfc&"
import script from "./ConfirmAtivarInativarDoseModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAtivarInativarDoseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports